function NotFound() {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="text-center py-5">
            <p className="fs-1 fw-bolder"> 404 - Page not found</p>
            <p className="fs-4 fw-bold">
              Sorry, the page you are looking for doesn't exist or has been
              moved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotFound;
